import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMyComplaints } from '../../services/complianceService';
import { getSeverityBadge } from '../../services/complianceService';
import toast from 'react-hot-toast';
import BackButtonBottom from '../../components/common/BackButtonBottom';

export default function MyComplaints() {
  const navigate = useNavigate();
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyComplaints()
      .then((res) => setComplaints(res.complaints || []))
      .catch((err) => toast.error(err.message || 'Could not load complaints'))
      .finally(() => setLoading(false));
  }, []);

  const statusLabel = {
    submitted: 'Submitted — awaiting acknowledgement',
    acknowledged: 'Acknowledged — under review',
    investigating: 'Under investigation',
    awaiting_complainant: 'Awaiting your response',
    resolved: 'Resolved',
    escalated_to_commissioner: 'Escalated to NSW Commissioner',
  };

  return (
    <div className="max-w-[700px] mx-auto p-6">
      <div className="mb-4">
        <button onClick={() => navigate('/rider')} className="bg-transparent border-0 text-brand-primary font-semibold text-[0.9rem] cursor-pointer p-0">← Dashboard</button>
      </div>

      <h1 className="font-serif mt-0 mb-2">My complaints</h1>
      <p className="text-body text-[0.9rem] mb-6">
        Formal complaints you've submitted.
      </p>

      <button onClick={() => navigate('/rider/complaint/new')} className="w-full p-3 rounded-xl border-[1.5px] border-dashed bg-white cursor-pointer font-semibold mb-4"
        style={{ borderColor: '#ff6b6b', color: '#ff6b6b' }}>+ Submit a new complaint</button>

      {loading && <div className="p-10 text-center text-muted">Loading...</div>}

      {!loading && complaints.length === 0 && (
        <div className="p-10 text-center text-muted bg-white rounded-2xl border border-slate-200">
          You haven't submitted any complaints.
        </div>
      )}

      <div className="grid gap-3">
        {complaints.map((c) => {
          const sev = getSeverityBadge(c.severity);
          const created = c.createdAt?._seconds ? new Date(c.createdAt._seconds * 1000) : new Date(c.createdAt);
          return (
            <div key={c.id} className="p-4 rounded-2xl bg-white border border-slate-200">
              <div className="flex justify-between items-start mb-1.5">
                <div className="font-bold text-brand-dark">{c.referenceNumber}</div>
                <span className="px-2.5 py-[3px] rounded-full text-[0.7rem] font-bold" style={{ background: sev.bg, color: sev.color }}>
                  {sev.label}
                </span>
              </div>
              <div className="text-[0.85rem] text-brand-dark mb-1 font-semibold">{c.categoryLabel}</div>
              <div className="text-[0.8rem] text-body mb-1">
                {c.description.length > 100 ? c.description.substring(0, 100) + '...' : c.description}
              </div>
              <div className="flex justify-between mt-2 text-[0.78rem]">
                <span className="text-body">{statusLabel[c.status] || c.status}</span>
                <span className="text-muted">{created.toLocaleDateString('en-AU')}</span>
              </div>
            </div>
          );
        })}
      </div>
    <BackButtonBottom to="/rider" label="Dashboard" />
    </div>
  );
}